module.exports = __webpack_public_path__ + "7f332733cfb81a63b23f8eb9af3a1ccc.svg";